import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import useJwt from '../auth/jwt/useJwt'

const LS_KEY = 'feedBookmakersAdsData'
const LS_TIMESTAMP_KEY = 'feedBookmakersAdsDataTimestamp'
const TEN_MINUTES = 10 * 60 * 1000

export const fetchFeedBookmakersAdsData = createAsyncThunk(
  'feedBookmakersAdsData/fetchFeedBookmakersAdsData',
  async () => {
    const now = Date.now()
    const cachedData = JSON.parse(localStorage.getItem(LS_KEY) || 'null')
    const cachedTimestamp = parseInt(localStorage.getItem(LS_TIMESTAMP_KEY) || '0', 10)

    if (cachedData && (now - cachedTimestamp < TEN_MINUTES)) {
      return cachedData
    }

    const response = await useJwt.getFeedBookmakersAds()
    localStorage.setItem(LS_KEY, JSON.stringify(response.data))
    localStorage.setItem(LS_TIMESTAMP_KEY, now.toString())
    return response.data
  }
)

const feedBookmakersAdsDataSlice = createSlice({
  name: 'feedBookmakersAdsData',
  initialState: {
    data: null,
    status: 'idle',
    error: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchFeedBookmakersAdsData.pending, state => {
        state.status = 'loading'
      })
      .addCase(fetchFeedBookmakersAdsData.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
      })
      .addCase(fetchFeedBookmakersAdsData.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })
  }
})

export default feedBookmakersAdsDataSlice.reducer
